export const AI_AGENTS = [
    { name: 'Sofia', description: 'Q&A AI Agent', img: '/assets/agents/sofia-agent.svg' },
]